<template>
   <v-speed-dial
      id="create"
      v-model="fab"
      bottom
      right
      direction="top"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          :color="color"
          dark
          fab
          large
        >
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-dots-horizontal
          </v-icon>
        </v-btn>
      </template>
      <v-btn
        v-for="(item, index) of dial"
        :key="index"
        dark
        small
        fab
        :color="item.color"
        style="cursor:default"
      >
      <v-layout wrap style="width:200px;margin-right:151px">
        <v-flex xs9 style="text-align:right;padding-top:5px;">
          {{getTranslation(item.label,locale)}}
        </v-flex>
        <v-flex xs3>
        <v-icon
          style="cursor: pointer"
          @click="handleClick(item)"
        >{{item.icon}}</v-icon>
        </v-flex>
      </v-layout>
      </v-btn>
    </v-speed-dial>
    <!--v-btn 
       v-if="showWhatsApp"
        color="#25D366"
        fab
        large
        dark
        style="position:fixed;right:10px;bottom:90px;"
        @click="handleSendWhatsApp"
      >
        <v-icon>mdi-whatsappd</v-icon>
      </v-btn-->
</template>
<script>
  import utils from '@/services/utils'
  import api from '@/services/api'
  export default {
    props: {
      color: {
         type: String,
        required: true,
      },
      dial: {
        type: Array,
        required: true,
      },
      locale: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        fab: false,
        whatsApp: false,
	      whatsAppAuth: true,
	      whatsAppPhone: '',
	      showWhatsApp: false,
      }
    },
    watch: {
      '$store.state.app.authData' () {
        this.prepareWhatsApp()
      }
    },
    mounted () {
      const enterpriseIDDomain = this.$store.state.app.enterpriseID ? this.$store.state.app.enterpriseID : utils.getDomain()
      api.getItem('utils', false, `whatsapp/${enterpriseIDDomain}`).then(response => {
	      this.whatsAppPhone = response.WhatsAppPhone
	      this.whatsApp = response.WhatsApp === 1
        this.whatsAppAuth = response.WhatsAppAuth === 1
        this.prepareWhatsApp()
      })
    },
    methods: {
      getTranslation(v, locale) {
        if(!v) return ''
        return utils.getTranslation(v , locale)
      },
      prepareWhatsApp () {
        if (this.whatsApp && this.whatsAppPhone.length > 0) {
          if (!this.whatsAppAuth || this.$store.state.app.authData) this.showWhatsApp = true
          else this.showWhatsApp = false
        } else this.showWhatsApp = false
      },
      handleSendWhatsApp () {
        //const url = `https://wa.me/${this.whatsAppPhone}?text=I'm%20interested%20in%20your%20car%20for%20sale`
        const url = `https://wa.me/${this.whatsAppPhone}?text=`
        window.location.href = url
      },
      handleClick (item) {
        let url = item.URL
        if (item.id === "whatsapp") {
          url = `https://wa.me/${item.URL}?text=`
        }
        window.location.href = url
      },
    }
  }
</script>
<style scoped>
#create {
  position:fixed;
  right:15px;
  bottom:10px;
}
  /* This is for documentation purposes and will not be needed in your application */
    /*
  #create .v-speed-dial {
    position: absolute;
  }

  #create .v-btn--floating {
    position: relative;
  }
    */
</style>

